import React, { Component } from 'react';
import InfiniteCalendar from 'react-infinite-calendar';
import 'react-infinite-calendar/styles.css';

class Calendar extends Component {
    state = {  }

    diaSelect = (dia) => {
        let date = dia;

        let day = date.getDate();
        let month = date.getMonth() + 1;
        let year = date.getFullYear();

        let diaSelect = `${day}/${month}/${year}`;

        this.props.funcion(diaSelect)
    }
    
    render() {
        return (
            <InfiniteCalendar
                width="100%"
                height={250}
                selected={this.props.today}
                disabledDays={[0,6]}
                locale={{
                    locale: require('date-fns/locale/es'),
                    headerFormat: 'dddd, D MMM',
                    weekdays: ["Dom","Lun","Mar","Mier","Jue","Vie","Sab"],
                    todayLabel: {
                        long: 'Hoy',
                        short: 'Hoy'
                    }
                }}
                theme={{
                    selectionColor: 'rgb(31, 47, 110)',
                    textColor: {
                      default: '#333',
                      active: '#FFF'
                    },
                    weekdayColor: 'rgb(168, 0, 18)',
                    headerColor: 'rgb(31, 47, 110)',
                    floatingNav: {
                      background: 'rgba(16, 39, 39, 0.96)',
                      color: '#FFF',
                      chevron: 'rgba(255, 255, 255, 0)'
                    }
                }}
                onSelect={(date) => { this.diaSelect(date) }}
            />
        );
    }
}
 
export default Calendar;


// WEBPACK FOOTER //
// ./src/views/Noticias/Calendar.jsx